// extracted by mini-css-extract-plugin
module.exports = {"AddSnippetForm":"AddSnippetForm_AddSnippetForm__1HpWo","labelSelection":"AddSnippetForm_labelSelection__2K9I-","AddSnippetFormHeader":"AddSnippetForm_AddSnippetFormHeader__1fvbT"};